import { render, staticRenderFns } from "./RegistraVisita.vue?vue&type=template&id=a4a04680&scoped=true"
import script from "./RegistraVisita.vue?vue&type=script&lang=js"
export * from "./RegistraVisita.vue?vue&type=script&lang=js"
import style0 from "./RegistraVisita.vue?vue&type=style&index=0&id=a4a04680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a04680",
  null
  
)

export default component.exports